var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7075 10.7075L14.7075 19.7075C14.5199 19.8951 14.2654 20.0006 14 20.0006C13.7346 20.0006 13.4801 19.8951 13.2925 19.7075C13.1049 19.5199 12.9994 19.2654 12.9994 19C12.9994 18.7346 13.1049 18.4801 13.2925 18.2925L20.5863 11H1C0.734784 11 0.48043 10.8947 0.292893 10.7071C0.105357 10.5196 0 10.2652 0 10C0 9.73479 0.105357 9.48044 0.292893 9.2929C0.48043 9.10536 0.734784 9.00001 1 9.00001H20.5863L13.2925 1.70751C13.1049 1.51987 12.9994 1.26537 12.9994 1.00001C12.9994 0.734643 13.1049 0.480147 13.2925 0.292507C13.4801 0.104866 13.7346 -0.000549316 14 -0.000549316C14.2654 -0.000549316 14.5199 0.104866 14.7075 0.292507L23.7075 9.29251C23.8005 9.38538 23.8742 9.49567 23.9246 9.61707C23.9749 9.73846 24.0008 9.86859 24.0008 10C24.0008 10.1314 23.9749 10.2615 23.9246 10.3829C23.8742 10.5043 23.8005 10.6146 23.7075 10.7075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowVector);
export default __webpack_public_path__ + "static/media/right-arrow-vector.29aedaa1ffbc347e7c9ae40c4a6ad09e.svg";
export { ForwardRef as ReactComponent };